<template>
  <ModuleSection title="U盾证书更新">
    <el-form
      ref="form"
      label-width="180px"
      :model="formData">
      <el-row :gutter="40">
        <!-- 汇款人姓名 -->
        <el-col
          :span="24"
          v-for="item in formItemList"
          :key="item.prop">
          <el-form-item
            :label="$t(item.label) + ':'"
            v-show="item.type">
            <template>
              <div :class="['item', {active : item.prop === 'customerNameCN'}]">
                {{formData[item.prop]}}{{item.subfix || ''}}
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="button-group">
      <el-button
        class="button"
        @click="handleUpdate">
        {{$t('证书更新')}}
      </el-button>
    </div>
    <div class="bottom-tip">
      <img
        class="img"
        src="~@/assets/image/icons/icon_input_tips.png"
        alt="icon_input_tips">
      <div class="tip">
        <div class="title">
          {{$t('温馨提示')}}
        </div>
        <div class="desc">
          {{ $t("证书到期日前三个月才可进行证书更新，更新成功后请重新登录网银确认新证书到期日期") }}
        </div>
      </div>
    </div>
  </ModuleSection>
</template>
<script>
import { mapState } from 'vuex'
import { certUpdate, certUpdateSubmit } from '../api'
import homeApi from '@/views/home/api/index'
export default {
  data () {
    return {
      formItemList: [
        { label: '企业名称', prop: 'customerNameCN', type: true },
        { label: '用户名称', prop: 'userName', type: true },
        { label: '用户编号', prop: 'userId', type: true },
        { label: '扣费账号', prop: 'toAcc', type: false },
        { label: 'U盾费用', prop: 'femAmount', type: false, subfix: this.$t('美元') },
        { label: '证书申请日期', prop: 'beginDate', type: true },
        { label: '证书到期日期', prop: 'endDate', type: true }
      ],
      formData: {}
    }
  },
  computed: {
    ...mapState('home', [
      'sessionInfo',
      'sessionData'
    ])
  },
  mounted () {
    this.formData = {
      customerId: this.sessionInfo.session_customerId,
      userId: this.sessionInfo.session_userId,
      customerNameCN: this.sessionData.session_customerNameEN, // session_customerNameEN   customerName
      userName: this.sessionInfo.userName
    }
    this.getInfo()
  },
  methods: {
    getInfo () {
      certUpdate().then(res => {
        if (res) {
          this.formData = {
            ...this.formData,
            USBKeyType: res.USBKeyType,
            USBKey: res.USBKey,
            beginDate: this.$_format.parseDate(res.beginDate, 'yyyymmddhhmiss').format('yyyy-mm-dd'),
            endDate: this.$_format.parseDate(res.endDate, 'yyyymmddhhmiss').format('yyyy-mm-dd'),
            femAmount: res.femAmount
          }
        }
      })
    },
    handleUpdate () {
      homeApi.getServerDateTime().then(res => {
        const {
          USBKeyType,
          USBKey,
          beginDate,
          femAmount,
          endDate
        } = this.formData
        const threeMonthsAgo = this.$_format.getLastMonth(endDate, '3')
        const currentDate = this.$_format.parseDate(res.dateTime, 'yyyymmddhhmiss').format('yyyy-mm-dd')
        if (currentDate < threeMonthsAgo) {
          this.$talert('您的证书还未到期，无需更新')
          return
        }
        // FIXME: 跳转之后的逻辑在旧企业网银环境下是无法正常进行的 需要产品进行重新规划设计
        certUpdateSubmit({
          currentBusinessCode: '10109989',
          toAmount: femAmount
        }).then(res => {
          this.$router.push({
            name: 'UpdateCertDown',
            query: {
              USBKeyType: USBKeyType,
              USBKey: USBKey,
              beginDate: beginDate,
              endDate: endDate
            }
          })
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.item {
  width: 500px;
  height: 46px;
  border-radius: 4px;
  border: 1px solid #e6e9f4;
  padding: 0 16px;
  line-height: 46px;
  &.active {
    color: #C0C4CC;
    background: #f6f7fc;
  }
}
.button-group {
  .button {
    min-width: 140px;
  }
}

.bottom-tip {
  display: flex;
  margin-top: 40px;
  .img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .tip {
    font-size: 12px;
    .title {
      font-weight: 300;
      color: #5a607f;
      line-height: 20px;
    }
    .desc {
      margin-top: 12px;
      font-weight: 300;
      color: #a1a7c4;
      line-height: 12px;
    }
  }
}
</style>
